import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { EnemySection } from '../components/EnemySection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { OfferSection } from '../components/OfferSection';
import { BonusSection } from '../components/BonusSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CloseSection } from '../components/CloseSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-navy text-white selection:bg-gold selection:text-navy" data-id="element-170">
      <HeroSection data-id="element-171" />
      <PainSection data-id="element-172" />
      <EnemySection data-id="element-173" />
      <SolutionSection data-id="element-174" />
      <WhatInsideSection data-id="element-175" />
      <OfferSection data-id="element-176" />
      <BonusSection data-id="element-177" />
      <GuaranteeSection data-id="element-178" />
      <CloseSection data-id="element-179" />
    </main>;
}